import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const location = useLocation();
  const isDocsPage =
    location.pathname.startsWith('/api-docs') ||
    location.pathname.startsWith('/frontend-docs');

  // For docs pages, don't wrap with Layout header (DocsViewer has its own layout)
  if (isDocsPage) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Link to="/" className="text-2xl font-bold text-gray-900 hover:text-gray-700">
                  Promang Docs
                </Link>
                <p className="text-sm text-gray-500">
                  Unified API & Frontend Documentation
                </p>
              </div>
              <div className="hidden md:block ml-10">
                <nav className="flex space-x-8">
                  <Link
                    to="/"
                    className={`px-3 py-2 text-sm font-medium ${
                      location.pathname === '/' ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    Home
                  </Link>
                  <Link
                    to="/api-docs"
                    className={`px-3 py-2 text-sm font-medium ${
                      location.pathname.startsWith('/api-docs') ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    API Documentation
                  </Link>
                  <Link
                    to="/frontend-docs"
                    className={`px-3 py-2 text-sm font-medium ${
                      location.pathname.startsWith('/frontend-docs') ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    Frontend Documentation
                  </Link>
                  <Link
                    to="/api-reference"
                    className={`px-3 py-2 text-sm font-medium ${
                      location.pathname.startsWith('/api-reference') ? 'text-primary-600 border-b-2 border-primary-600' : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    OpenAPI
                  </Link>
                  <Link
                    to="/component-library"
                    className={`px-3 py-2 text-sm font-medium ${
                      location.pathname.startsWith('/component-library')
                        ? 'text-primary-600 border-b-2 border-primary-600'
                        : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    Komponentbibliotek
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>
    </div>
  );
};

export default Layout;

